export default __webpack_public_path__ + "static/newsone-681b5210058bb272ba0f07ae2714db77.png";